import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import styles from './TitleElement.module.scss';
export const TitleElementTitle = observer(({ $element }) => {
    const { config, renderParams } = $element;
    return (_jsx(Title, Object.assign({ size: $element.config.variant, className: classNames(styles.title, renderParams.className) }, { children: config.text })));
});
export const TitleElementDefault = observer(({ $element }) => {
    const { config, renderParams } = $element;
    return _jsx("div", Object.assign({ className: classNames(styles.default, renderParams.className) }, { children: config.text }));
});
